import { ArrowUpRight, CalendarClock, HeartHandshake, ScrollText, ShieldCheck } from "lucide-react";
import { Eyebrow, Reveal, goTo } from "@/components/Reveal";
import { useLang } from "@/i18n/LanguageContext";

const CARD_LAYOUT = [
  { icon: ShieldCheck, tag: "01", span: "lg:col-span-2", image: "https://images.unsplash.com/photo-1622485745775-f4344e2da17e?q=80&w=1200&auto=format&fit=crop" },
  { icon: ScrollText, tag: "02", span: "" },
  { icon: HeartHandshake, tag: "03", span: "" },
  { icon: CalendarClock, tag: "04", span: "lg:col-span-2", cta: true },
];

export default function Services() {
  const { t } = useLang();
  return (
    <section id="services" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <div className="mb-14 grid gap-8 lg:grid-cols-[1fr_0.8fr] lg:items-end">
          <Reveal>
            <Eyebrow className="mb-5">{t.services.eyebrow}</Eyebrow>
            <h2 className="font-display text-4xl font-semibold leading-[1.05] text-cream sm:text-5xl lg:text-6xl">
              {t.services.titleA}
              <br />
              <span className="italic text-gold-grad">{t.services.titleB}</span>
              {t.services.titleC}
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="max-w-md text-base leading-relaxed text-cream/65 lg:ml-auto">
              {t.services.intro}
            </p>
          </Reveal>
        </div>

        <div className="grid gap-5 lg:grid-cols-3" data-testid="services-grid">
          {CARD_LAYOUT.map((layout, i) => (
            <Reveal key={layout.tag} delay={i * 0.1} className={layout.span}>
              <article className="card-lift group relative h-full overflow-hidden rounded-2xl border border-gold/15 bg-navy2/70 p-8">
                {layout.image && (
                  <img
                    src={layout.image}
                    alt=""
                    aria-hidden="true"
                    className="pointer-events-none absolute -right-10 -top-14 h-64 w-64 rounded-full object-cover opacity-25 [mask-image:radial-gradient(circle,black,transparent_72%)]"
                  />
                )}
                <div className="relative flex h-full flex-col">
                  <div className="mb-8 flex items-start justify-between">
                    <span className="flex h-12 w-12 items-center justify-center rounded-full border border-gold/30 bg-gold/10">
                      <layout.icon className="h-5 w-5 text-gold" />
                    </span>
                    <span className="font-mono text-xs tracking-[0.3em] text-gold/50">{layout.tag}</span>
                  </div>
                  <h3 className="font-display text-2xl font-semibold text-cream sm:text-[1.7rem]">{t.services.cards[i].title}</h3>
                  <p className="mt-4 max-w-lg text-sm leading-relaxed text-cream/65 sm:text-base">{t.services.cards[i].body}</p>
                  {layout.cta && (
                    <a
                      href="#consult"
                      onClick={(e) => goTo(e, "#consult")}
                      data-testid="services-private-quote-cta"
                      className="mt-auto inline-flex items-center gap-2 pt-6 text-sm font-semibold uppercase tracking-[0.16em] text-gold transition-colors duration-300 hover:text-gold-light"
                    >
                      {t.services.cta}
                      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </a>
                  )}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
